var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UsersThree",
    clipPath: "url(#clip0_2425_201766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.59375C10.2231 6.5934 10.6897 6.70337 11.1128 6.91493C11.536 7.1265 11.9039 7.43383 12.1875 7.8125",
    fill: "#AA93FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6.59375C10.2231 6.5934 10.6897 6.70337 11.1128 6.91493C11.536 7.1265 11.9039 7.43383 12.1875 7.8125",
    stroke: "#AA93FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.8125 7.8125C1.09606 7.43383 1.46402 7.1265 1.88715 6.91493C2.31029 6.70337 2.77693 6.5934 3.25 6.59375",
    stroke: "#AA93FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.5 9.84375C7.62183 9.84375 8.53125 8.93433 8.53125 7.8125C8.53125 6.69067 7.62183 5.78125 6.5 5.78125C5.37817 5.78125 4.46875 6.69067 4.46875 7.8125C4.46875 8.93433 5.37817 9.84375 6.5 9.84375Z",
    stroke: "#AA93FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.65625 11.4688C3.94788 10.9739 4.36361 10.5636 4.86235 10.2787C5.36109 9.99366 5.92558 9.84375 6.5 9.84375C7.07442 9.84375 7.63891 9.99366 8.13765 10.2787C8.63639 10.5636 9.05212 10.9739 9.34375 11.4688",
    stroke: "#AA93FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.17578 4.5625C8.25176 4.26826 8.40872 4.00121 8.62884 3.79169C8.84897 3.58218 9.12343 3.43858 9.42107 3.37722C9.7187 3.31586 10.0276 3.33919 10.3126 3.44456C10.5977 3.54993 10.8474 3.73312 11.0336 3.97332C11.2198 4.21352 11.3348 4.50112 11.3657 4.80343C11.3967 5.10575 11.3422 5.41068 11.2085 5.68359C11.0748 5.9565 10.8673 6.18646 10.6095 6.34735C10.3517 6.50823 10.0539 6.5936 9.75 6.59375",
    stroke: "#AA93FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.25001 6.59375C2.94611 6.5936 2.64835 6.50823 2.39053 6.34735C2.13272 6.18646 1.92519 5.9565 1.7915 5.68359C1.65782 5.41068 1.60334 5.10575 1.63426 4.80343C1.66517 4.50112 1.78024 4.21352 1.9664 3.97332C2.15256 3.73312 2.40234 3.54993 2.68738 3.44456C2.97243 3.33919 3.2813 3.31586 3.57894 3.37722C3.87658 3.43858 4.15104 3.58218 4.37116 3.79169C4.59129 4.00121 4.74825 4.26826 4.82422 4.5625",
    stroke: "#AA93FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_201766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactList);
export default __webpack_public_path__ + "static/media/contact_list.22556681e2b3423fbe8859310b4babff.svg";
export { ForwardRef as ReactComponent };